<template>
  <div class="warehouse-module">
    <div class="container">
      <div class="header">
        <h1>{{ current.title }}</h1>
        <p>{{ current.subtitle }}</p>
      </div>

      <router-view />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const tabs = [
  {
    to: '/warehouse',
    match: ['/warehouse'],
    label: 'Dashboard',
    icon: 'fa-solid fa-chart-line',
    title: 'Warehouse Dashboard',
    subtitle: 'Inventory visibility, hygiene, sales value, GP% and category performance'
  },
  {
    to: '/warehouse/inventory',
    match: ['/warehouse/inventory'],
    label: 'Inventory',
    icon: 'fa-solid fa-boxes-stacked',
    title: 'Inventory',
    subtitle: 'Product master (catalogue) and stock by warehouse — with expiry hygiene'
  },
  {
    to: '/warehouse/clinic',
    match: ['/warehouse/clinic'],
    label: 'Clinic',
    icon: 'fa-solid fa-clinic-medical',
    title: 'Clinic dispensary',
    subtitle: 'SCMS clinic medications by clinic_id — fills the Dashboard Clinic site type'
  },
  {
    to: '/warehouse/dental',
    match: ['/warehouse/dental'],
    label: 'Dental',
    icon: 'fa-solid fa-tooth',
    title: 'Dental inventory',
    subtitle: 'SDMS dental medications by dental_id — Putrajaya (1) & Unisel (3)'
  },
  {
    to: '/warehouse/orders',
    match: ['/warehouse/orders'],
    label: 'Orders & DO',
    icon: 'fa-solid fa-truck-medical',
    title: 'Orders & delivery notes',
    subtitle: 'SAP sales orders and delivery notes — ordered, pending, and fulfilled (DO)'
  },
  {
    to: '/warehouse/sales',
    match: ['/warehouse/sales'],
    label: 'Sales',
    icon: 'fa-solid fa-cart-shopping',
    title: 'Sales (SAP invoices)',
    subtitle: 'A/R invoice lines — billed revenue (UnitPrice), invoice COGS (GrossBuyPrice), and invoice GP'
  },
  {
    to: '/warehouse/data-flow',
    match: ['/warehouse/data-flow'],
    label: 'Data Flow',
    icon: 'fa-solid fa-diagram-project',
    title: 'Data flow & integrations',
    subtitle: 'SAP HIS, SAP Selgate Group, CSV import, ingest endpoints and sync history'
  },
  {
    to: '/warehouse/sources',
    match: ['/warehouse/sources'],
    label: 'Sources & Mapping',
    icon: 'fa-solid fa-shuffle',
    title: 'Sources & field mapping',
    subtitle: 'Register environments and map source fields to SECTOR warehouse parameters'
  }
]

const current = computed(() => tabs.find((tab) => isActive(tab)) || tabs[0])

function isActive(tab) {
  return tab.match.includes(route.path)
}
</script>

<style scoped>
.warehouse-module {
  padding: 24px;
  background: #f8fafc;
  min-height: 100vh;
  width: 100%;
}

.container {
  width: 100%;
  margin: 0 auto;
}

.header {
  margin-bottom: 16px;
}

.header h1 {
  font-size: 1.875rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.header p {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
}

@media (max-width: 768px) {
  .warehouse-module {
    padding: 12px;
  }
}
</style>
